import { useAtom } from 'jotai'
import { AdvanceComp } from '../ai-form/AdvanceComp'
import { CharacterComp } from '../ai-form/CharacterComp'
import { ModelFusionComp } from '../ai-form/ModelFusionComp'
import { ModelThemeComp } from '../ai-form/ModelThemeComp'
import { PictureResolutionComp } from '../ai-form/PictureResolutionComp'
import { PictureSizeComp } from '../ai-form/PictureSizeComp'
import { PromptComp } from '../ai-form/PromptComp'
import { UcPropmtComp } from '../ai-form/UcPropmtComp'
import { VipParamsComp } from '../ai-form/VipParamsComp'
import { hasAdvanceAtom } from '../ai-form/atom'
import { TransparentParamComp } from '../ai-form/TransparentParamComp'

export const TransparentFormContent = () => {
  /** 高级选项 */
  const [hasAdvance] = useAtom(hasAdvanceAtom)

  return (
    <>
      {/* 画面描述 */}
      <PromptComp />

      {/* 画面大小和尺寸 */}
      <PictureSizeComp />
      {/*  产品要求隐藏，处理字段必传，因而只是隐藏form-item */}
      <PictureResolutionComp hidden />

      {/* 模型主题 */}
      <ModelThemeComp />

      {/** 高级设置 */}
      <AdvanceComp />

      {hasAdvance && (
        <>
          {/* 透明图参数 */}
          <TransparentParamComp />

          {/* 负面描述 */}
          <UcPropmtComp />

          {/** 角色同人 */}
          <CharacterComp />

          {/** 融合模型 */}
          <ModelFusionComp />

          {/* 会员专享参数 */}
          <VipParamsComp />
        </>
      )}
    </>
  )
}
